import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    avatarImage: {
        height: 70,
        width: 70
    },
    avatarPlaceholder: {
        height: 70,
        justifyContent: "center",
        width: 70
    },
    container: {
        alignItems: "center"
    },
    textCenter: {
        textAlign: "center"
    }
});
export default stylesheet;
